import locale from 'localization';

export const initialState = (state = {}) => {
  const {
    firstName = {
      value: '',
      disabled: true
    },
    lastName = {
      value: '',
      disabled: true
    },
    middleName = {
      value: '',
      disabled: false
    },
    gender = {
      value: '',
      disabled: false
    },
    civilStatus = {
      value: '',
      disabled: false
    },
    address = {
      value: '',
      disabled: false
    },
    dateOfBirth = {
      value: '',
      disabled: false
    },
    placeOfBirth = {
      value: '',
      disabled: false
    },
    tinNo = {
      value: '',
      disabled: false
    },
    philhealthNo = {
      value: '',
      disabled: false
    },
    pagibigNo = {
      value: '',
      disabled: false
    },
    sssNo = {
      value: '',
      disabled: false
    },
    mobileNumber = {
      value: '',
      disabled: false
    },
    emailAddress = {
      value: '',
      disabled: false
    },
    religion = {
      value: '',
      disabled: false
    },
    educationalAttainment = {
      value: '',
      disabled: false
    },
    work = {
      value: '',
      disabled: false
    },
    spouseName = {
      value: '',
      disabled: false
    },
    spouseWork = {
      value: '',
      disabled: false
    },
    fatherName = {
      value: '',
      disabled: false
    },
    motherName = {
      value: '',
      disabled: false
    },
    emergencyContactName = {
      value: '',
      disabled: false
    },
    emergencyContactAddress = {
      value: '',
      disabled: false
    },
    emergencyContactNumber = {
      value: '',
      disabled: false
    },
    emergencyContactRelationship = {
      value: '',
      disabled: false
    },
    type = {
      value: '',
      disabled: false
    },
    membershipId = {
      value: '',
      disabled: false
    },
    bodApprovalDate = {
      value: '',
      disabled: false
    },
    boardResolutionNumber = {
      value: '',
      disabled: false
    }
  } = state;
  return {
    firstName: {
      name: 'firstName',

      label: locale.firstName,
      required: true,
      ...firstName
    },
    lastName: {
      name: 'lastName',

      label: locale.lastName,
      required: true,
      ...lastName
    },
    middleName: {
      name: 'middleName',
      label: 'Middle Name',
      required: false,
      ...middleName
    },
    address: {
      name: 'address',

      label: 'Address',
      required: false,
      ...address
    },
    dateOfBirth: {
      name: 'dateOfBirth',

      label: 'Date of Birth',
      required: false,
      placeholder: 'MM/DD/YYYY',
      ...dateOfBirth
    },
    placeOfBirth: {
      name: 'placeOfBirth',

      label: 'Place of Birth',
      required: false,
      ...placeOfBirth
    },
    civilStatus: {
      name: 'civilStatus',

      label: 'Civil Status',
      required: false,
      ...civilStatus
    },
    gender: {
      name: 'gender',

      maxLength: 75,
      label: 'Gender',
      required: false,
      ...gender
    },
    tinNo: {
      name: 'tinNo',

      label: 'Tin No.',
      placeholder: 'XXX-XXX-XXX',
      upperCase: true,
      required: false,
      ...tinNo
    },
    pagibigNo: {
      name: 'pagibigNo',

      label: 'Pag-Ibig No.',
      placeholder: 'XXXX-XXXX-XXXX',
      upperCase: true,
      required: false,
      ...pagibigNo
    },
    sssNo: {
      name: 'sssNo',

      label: 'SSS No.',
      placeholder: 'XX-XXXXXXX-X',
      upperCase: true,
      required: false,
      ...sssNo
    },
    philhealthNo: {
      name: 'philhealthNo',

      label: 'Philhealth No.',
      placeholder: 'XXXX-XXXX-XXXX',
      upperCase: true,
      required: false,
      ...philhealthNo
    },
    mobileNumber: {
      name: 'mobileNumber',

      maxLength: 11,
      label: 'Mobile Number',
      placeholder: '09XXXXXXXXX',
      required: false,
      ...mobileNumber
    },
    emailAddress: {
      name: 'emailAddress',
      label: 'Email Address',

      required: false,
      ...emailAddress
    },
    religion: {
      name: 'religion',
      label: 'Religion',

      required: false,
      ...religion
    },
    spouseName: {
      name: 'spouseName',
      label: 'Name of Spouse',
      ...spouseName
    },
    spouseWork: {
      name: 'spouseWork',
      label: 'Work',
      ...spouseWork
    },
    educationalAttainment: {
      name: 'educationalAttainment',
      label: 'Educational Attainment',
      ...educationalAttainment
    },
    work: {
      name: 'work',
      label: 'Work',
      ...work
    },
    fatherName: {
      name: 'fatherName',
      label: `Father's Name`,
      ...fatherName
    },
    motherName: {
      name: 'motherName',
      label: `Mother's Name`,
      ...motherName
    },
    emergencyContactName: {
      name: 'emergencyContactName',
      label: `Emergency Contact Name`,
      ...emergencyContactName
    },
    emergencyContactNumber: {
      name: 'emergencyContactNumber',
      label: `Contact Number`,
      ...emergencyContactNumber
    },
    emergencyContactRelationship: {
      name: 'emergencyContactRelationship',
      label: `Relationship`,
      ...emergencyContactRelationship
    },
    emergencyContactAddress: {
      name: 'emergencyContactAddress',
      label: `Address`,
      ...emergencyContactAddress
    },
    type: {
      name: 'type',
      label: `Membership Type`,
      required: false,
      ...type
    },
    boardResolutionNumber: {
      name: 'boardResolutionNumber',
      label: `Board Resolution Number`,
      required: false,
      ...boardResolutionNumber
    },
    bodApprovalDate: {
      name: 'bodApprovalDate',
      label: `BOD Approval Date`,
      required: false,
      ...bodApprovalDate
    },
    membershipId: {
      name: 'membershipId',
      label: `Membership ID`,
      required: false,
      ...membershipId
    }
  };
};
